import React, { useState } from 'react';
import PropTypes from 'prop-types';
import Dialog from '@material-ui/core/Dialog';
import IconButton from '@material-ui/core/IconButton';
import { withStyles } from '@material-ui/core/styles';

import VersionHistoryTable from '../shared';
import xIcon from '../../../../../core/assets/svg/x.svg';
import styles from '../versions.styles';
import Body from './body';
import ListHeader from './header';

const ModalBody = ({ versions, classes, onPageChange, count, page, onClose, state, currentVersion, policyType }) => {
  return (
    <>
      <div className={classes.dialogHeader}>
        <IconButton className={classes.dialogCloseButton} onClick={onClose}>
          <img src={xIcon} alt="Close" className={classes.dialogCloseButtonIcon} />
        </IconButton>
      </div>
      <div className={classes.dialogTitleContainer}>
        <div className={classes.dialogTitle}>Version History</div>
      </div>
      <VersionHistoryTable
        state={state}
        versions={versions}
        classes={{ table: classes.bigTable }}
        body={Body}
        header={ListHeader}
        onPageChange={onPageChange}
        count={count}
        page={page}
        currentVersion={currentVersion}
        policyType={policyType}
        closeVersionHistoryModal={onClose}
      />
    </>
  );
};

ModalBody.propTypes = {
  versions: PropTypes.array.isRequired,
  classes: PropTypes.object.isRequired,
  onPageChange: PropTypes.func.isRequired,
  count: PropTypes.number.isRequired,
  page: PropTypes.number.isRequired,
  onClose: PropTypes.func.isRequired,
  state: PropTypes.string.isRequired,
  currentVersion: PropTypes.number,
  policyType: PropTypes.string.isRequired
};

const Modal = ({ versions, open, onClose, classes, state, currentVersion, policyType }) => {
  const [page, setPage] = useState(0);

  const onPageChange = (_e, newPage) => {
    setPage(newPage);
  };

  return (
    <Dialog
      open={open}
      onClose={onClose}
      classes={{
        root: classes.dialogRoot,
        container: classes.backdrop,
        paper: classes.dialogPaper,
        scrollPaper: classes.scrollPaper
      }}
    >
      {open && (
        <ModalBody
          state={state}
          versions={versions.slice(page * 5, page * 5 + 5)}
          classes={classes}
          onPageChange={onPageChange}
          count={versions.length}
          page={page}
          onClose={onClose}
          currentVersion={currentVersion}
          policyType={policyType}
        />
      )}
    </Dialog>
  );
};

Modal.propTypes = {
  versions: PropTypes.array.isRequired,
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  classes: PropTypes.object.isRequired,
  state: PropTypes.string.isRequired,
  currentVersion: PropTypes.number,
  policyType: PropTypes.string.isRequired
};

export default withStyles(styles)(Modal);
